import React, { useState, useEffect } from 'react';
import { apiFetch } from '../utils/api';

// 注册页面组件
function RegisterPage() {
  // 状态：用户名、姓名、邮箱、密码、确认密码、错误信息
  const [username, setUsername] = useState('');
  const [realName, setRealName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  
  // 组织和小组相关状态
  const [organizations, setOrganizations] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState('');
  const [selectedGroup, setSelectedGroup] = useState('');
  const [loadingOrgs, setLoadingOrgs] = useState(false);

  // 组件加载时获取可用的组织和小组列表
  useEffect(() => {
    fetchOrganizations();
  }, []);

  const fetchOrganizations = async () => {
    setLoadingOrgs(true);
    try {
      const res = await apiFetch('/api/user/org-group-options');
      const data = await res.json();
      if (data.success) {
        setOrganizations(data.organizations || []);
      }
    } catch (e) {
      console.error('获取组织列表失败:', e);
    } finally {
      setLoadingOrgs(false);
    }
  };

  // 获取当前选中组织的小组列表
  const getAvailableGroups = () => {
    if (!selectedOrg) return [];
    const org = organizations.find(o => o.org_name === selectedOrg);
    return org?.groups || [];
  };

  // 注册处理函数
  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    if (password !== confirm) {
      setError('两次密码不一致');
      return;
    }
    try {
      // 调用后端API
      const res = await apiFetch('/api/user/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          username, 
          realName, 
          password, 
          email,
          orgName: selectedOrg || null,
          groupName: selectedGroup || null
        })
      });
      const data = await res.json();
      if (data.success) {
        setSuccess(true);
        setTimeout(() => window.location.href = '/login', 1500);
      } else {
        setError(data.error || '注册失败');
      }
    } catch (e) {
      setError('网络错误');
    }
  };

  return (
    <div style={{ maxWidth: 500, margin: '40px auto', padding: 20, border: '1px solid #ccc', borderRadius: 8 }}>
      <h2>用户注册</h2>
      <form onSubmit={handleRegister}>
        <div>
          <label>用户名：</label>
          <input value={username} onChange={e => setUsername(e.target.value)} required style={{ width: '100%', padding: 8, marginTop: 4 }} />
        </div>
        <div style={{ marginTop: 10 }}>
          <label>姓名：</label>
          <input value={realName} onChange={e => setRealName(e.target.value)} required style={{ width: '100%', padding: 8, marginTop: 4 }} />
        </div>
        <div style={{ marginTop: 10 }}>
          <label>邮箱：</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} required style={{ width: '100%', padding: 8, marginTop: 4 }} />
        </div>
        <div style={{ marginTop: 10 }}>
          <label>密码：</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} required style={{ width: '100%', padding: 8, marginTop: 4 }} />
        </div>
        <div style={{ marginTop: 10 }}>
          <label>确认密码：</label>
          <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required style={{ width: '100%', padding: 8, marginTop: 4 }} />
        </div>
        
        {/* 组织和小组选择 */}
        <div style={{ marginTop: 20, padding: 12, background: '#f5f5f5', borderRadius: 4 }}>
          <div style={{ marginBottom: 8, fontWeight: 'bold', color: '#333' }}>选择隶属组织(可选)</div>
          <div style={{ fontSize: 12, color: '#666', marginBottom: 12 }}>
            选择后,提权为队长/组长可管理对应范围的队员
          </div>
          
          <div>
            <label>一级组织：</label>
            <select 
              value={selectedOrg} 
              onChange={e => {
                setSelectedOrg(e.target.value);
                setSelectedGroup(''); // 清空小组选择
              }}
              disabled={loadingOrgs}
              style={{ width: '100%', padding: 8, marginTop: 4 }}
            >
              <option value="">请选择组织(可不选)</option>
              {organizations.map(org => (
                <option key={org.org_name} value={org.org_name}>
                  {org.org_name}
                </option>
              ))}
            </select>
          </div>
          
          {selectedOrg && (
            <div style={{ marginTop: 10 }}>
              <label>二级小组：</label>
              <select
                value={selectedGroup}
                onChange={e => setSelectedGroup(e.target.value)}
                style={{ width: '100%', padding: 8, marginTop: 4 }}
              >
                <option value="">请选择小组</option>
                {getAvailableGroups().map(group => (
                  <option key={group} value={group}>
                    {group === '所有' ? '所有(提权后可管理该组织下全部队员)' : group}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
        
        {error && <div style={{ color: 'red', marginTop: 10 }}>{error}</div>}
        {success && <div style={{ color: 'green', marginTop: 10 }}>注册成功，正在跳转...</div>}
        <button type="submit" style={{ marginTop: 20, width: '100%', padding: 10 }}>注册</button>
      </form>
    </div>
  );
}

export default RegisterPage; 